
function InputsContainer({ children }) {
  return <div className="w-full space-y-3">{children}</div>
}

export default InputsContainer
